import { render, staticRenderFns } from "./ApproveLeasesDialog.vue?vue&type=template&id=2ae9e4c6&scoped=true"
import script from "./ApproveLeasesDialog.vue?vue&type=script&lang=js"
export * from "./ApproveLeasesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae9e4c6",
  null
  
)

export default component.exports